"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strings = void 0;
exports.strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'ago',
  suffixFromNow: 'from now',
  seconds: 'less than 1m',
  minute: 'about 1m',
  minutes: '%dm',
  hour: 'about 1h',
  hours: 'about %dh',
  day: '1d',
  days: '%dd',
  month: 'about 1m',
  months: '%dm',
  year: 'about 1y',
  years: '%dy',
  wordSeparator: ' '
};
